// extracted by mini-css-extract-plugin
module.exports = {"propertyCard":"PropertyListings_propertyCard__lnlAI"};